var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1728",
    "data-name": "Groupe 1728",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.122,
    height: 37.122,
    viewBox: "0 0 37.122 37.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2784",
    "data-name": "Trac\\xE9 2784",
    d: "M0,0H37.122V37.122H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2785",
    "data-name": "Trac\\xE9 2785",
    d: "M23.674,21.146a4.043,4.043,0,0,0-2.7,1.047L11.146,16.55a4.4,4.4,0,0,0,.124-.952,4.4,4.4,0,0,0-.124-.952l9.717-5.589a4.147,4.147,0,0,0,2.812,1.1,4.08,4.08,0,1,0-4.135-4.079,4.4,4.4,0,0,0,.124.952L9.946,12.62a4.147,4.147,0,0,0-2.812-1.1,4.08,4.08,0,1,0,0,8.159,4.147,4.147,0,0,0,2.812-1.1l9.813,5.657a3.788,3.788,0,0,0-.11.884,4.025,4.025,0,1,0,4.025-3.971Zm0-16.426A1.36,1.36,0,1,1,22.3,6.079,1.373,1.373,0,0,1,23.674,4.72ZM7.135,16.958A1.36,1.36,0,1,1,8.513,15.6,1.373,1.373,0,0,1,7.135,16.958ZM23.674,26.5a1.36,1.36,0,1,1,1.378-1.36A1.373,1.373,0,0,1,23.674,26.5Z",
    transform: "translate(3.156 2.962)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.263935a8c81af92128568a3997eaa784.svg";
export { ForwardRef as ReactComponent };